import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// nl files
import commonNL from './common/nl.json';
import leftMenuNl from 'components/Menu/LeftMenu/translations/nl.json';
import tabsNl from 'components/Menu/Tabs/translations/nl.json';
import loginLayoutNl from 'layouts/Login/translations/nl.json';
import loginNl from 'screens/Account/Login/translations/nl.json';
import passwordForgottenNl from 'screens/Account/PasswordForgotten/translations/nl.json';
import resetPasswordNl from 'screens/Account/ResetPassword/translations/nl.json';
import manageAdminsNl from 'screens/Admin/ManageAdmins/translations/nl.json';
import adminDashboardNl from 'screens/Admin/Home/translations/nl.json';
import registerAdminNl from 'screens/Account/Register/Admin/translations/nl.json';
import manageAdminRightsNl from 'screens/Admin/ManageAdminRights/translations/nl.json';
import manageCompaniesNl from 'screens/Admin/ManageCompanies/translations/nl.json';
import editCompanyDetailsNl from 'screens/Admin/EditCompany/EditCompanyDetails/translations/nl.json';
import editCompanyCoatingsNl from 'screens/Admin/EditCompany/EditCompanyCoatings/translations/nl.json';
import addCompanyNl from 'screens/Admin/AddCompany/translations/nl.json';
import coatingConfiguratorCategoriesNl from 'screens/Admin/CoatingConfiguratorCategories/translations/nl.json';
import editCoatingConfiguratorCategoryNl from 'screens/Admin/EditCoatingConfiguratorCategory/translations/nl.json';
import coatingConfiguratorStepsNl from 'screens/Admin/CoatingConfiguratorSteps/translations/nl.json';
import editCoatingConfiguratorStepNl from 'screens/Admin/EditCoatingConfiguratorStep/translations/nl.json';
import coatingConfiguratorCoatingsNl from 'screens/Admin/CoatingConfiguratorCoatings/translations/nl.json';
import editCoatingConfiguratorCoatingNl from 'screens/Admin/EditCoatingConfiguratorCoating/translations/nl.json';
import userDashboardNl from 'screens/User/Home/translations/nl.json';
import manageBranchesNl from 'screens/Admin/ManageBranches/translations/nl.json';
import addBranchNl from 'screens/Admin/AddBranch/translations/nl.json';
import editBranchNl from 'screens/Admin/EditBranch/translations/nl.json';
import coatingConfiguratorProceduresNl from 'screens/Admin/CoatingConfiguratorProcedures/translations/nl.json';
import editCoatingConfiguratorProcedureNl from 'screens/Admin/EditCoatingConfiguratorProcedure/translations/nl.json';
import editCompanyProceduresNl from 'screens/Admin/EditCompanyProcedures/translations/nl.json';
import expertAdviserNl from 'screens/Admin/ExpertAdviser/translations/nl.json';
import customerAdviserNl from 'screens/Admin/CustomerAdviser/translations/nl.json';
import manageRightGroupsNl from 'screens/Admin/ManageRightGroups/translations/nl.json';
import knowledgeBaseNl from 'screens/Admin/KnowledgeBase/translations/nl.json';
import knowledgeBaseCategoriesNl from 'screens/Admin/KnowledgeBaseCategories/translations/nl.json';
import knowledgeBaseDetailNl from 'screens/Admin/KnowledgeBaseDetail/translations/nl.json';
import invoicesNl from 'screens/User/Invoices/translations/nl.json';
import registerCompanyUserNl from 'screens/Account/Register/CompanyUser/translations/nl.json';
import signUpCompanyUserNl from 'screens/Account/SignUp/translations/nl.json';
import userDeliveryNotesNl from 'screens/User/DeliveryNotes/translations/nl.json';
import EditCompanyRightsNl from 'screens/Admin/EditCompany/EditCompanyRights/translations/nl.json';
import manageCompanyUsersNl from 'screens/Admin/ManageCompanyUsers/translations/nl.json';

// en files
import commonEn from './common/en.json';
import leftMenuEn from 'components/Menu/LeftMenu/translations/en.json';
import tabsEn from 'components/Menu/Tabs/translations/en.json';
import loginLayoutEn from 'layouts/Login/translations/en.json';
import loginEn from 'screens/Account/Login/translations/en.json';
import passwordForgottenEn from 'screens/Account/PasswordForgotten/translations/en.json';
import resetPasswordEn from 'screens/Account/ResetPassword/translations/en.json';
import manageAdminsEn from 'screens/Admin/ManageAdmins/translations/en.json';
import adminDashboardEn from 'screens/Admin/Home/translations/en.json';
import registerAdminEn from 'screens/Account/Register/Admin/translations/en.json';
import manageAdminRightsEn from 'screens/Admin/ManageAdminRights/translations/en.json';
import manageCompaniesEn from 'screens/Admin/ManageCompanies/translations/en.json';
import editCompanyDetailsEn from 'screens/Admin/EditCompany/EditCompanyDetails/translations/en.json';
import editCompanyCoatingsEn from 'screens/Admin/EditCompany/EditCompanyCoatings/translations/en.json';
import addCompanyEn from 'screens/Admin/AddCompany/translations/en.json';
import coatingConfiguratorCategoriesEn from 'screens/Admin/CoatingConfiguratorCategories/translations/en.json';
import editCoatingConfiguratorCategoryEn from 'screens/Admin/EditCoatingConfiguratorCategory/translations/en.json';
import coatingConfiguratorStepsEn from 'screens/Admin/CoatingConfiguratorSteps/translations/en.json';
import editCoatingConfiguratorStepEn from 'screens/Admin/EditCoatingConfiguratorStep/translations/en.json';
import coatingConfiguratorCoatingsEn from 'screens/Admin/CoatingConfiguratorCoatings/translations/en.json';
import editCoatingConfiguratorCoatingEn from 'screens/Admin/EditCoatingConfiguratorCoating/translations/en.json';
import userDashboardEn from 'screens/User/Home/translations/en.json';
import manageBranchesEn from 'screens/Admin/ManageBranches/translations/en.json';
import addBranchEn from 'screens/Admin/AddBranch/translations/en.json';
import editBranchEn from 'screens/Admin/EditBranch/translations/en.json';
import coatingConfiguratorProceduresEn from 'screens/Admin/CoatingConfiguratorProcedures/translations/en.json';
import editCoatingConfiguratorProcedureEn from 'screens/Admin/EditCoatingConfiguratorProcedure/translations/en.json';
import editCompanyProceduresEn from 'screens/Admin/EditCompanyProcedures/translations/en.json';
import expertAdviserEn from 'screens/Admin/ExpertAdviser/translations/en.json';
import customerAdviserEn from 'screens/Admin/CustomerAdviser/translations/en.json';
import manageRightGroupsEn from 'screens/Admin/ManageRightGroups/translations/en.json';
import knowledgeBaseEn from 'screens/Admin/KnowledgeBase/translations/en.json';
import knowledgeBaseCategoriesEn from 'screens/Admin/KnowledgeBaseCategories/translations/en.json';
import knowledgeBaseDetailEn from 'screens/Admin/KnowledgeBaseDetail/translations/en.json';
import invoicesEn from 'screens/User/Invoices/translations/en.json';
import registerCompanyUserEn from 'screens/Account/Register/CompanyUser/translations/en.json';
import signUpCompanyUserEn from 'screens/Account/SignUp/translations/en.json';
import userDeliveryNotesEn from 'screens/User/DeliveryNotes/translations/en.json';
import EditCompanyRightsEn from 'screens/Admin/EditCompany/EditCompanyRights/translations/en.json';
import manageCompanyUsersEn from 'screens/Admin/ManageCompanyUsers/translations/en.json';

const resources = {
    nl: {
        common: commonNL,
        leftMenu: leftMenuNl,
        tabs: tabsNl,
        loginLayout: loginLayoutNl,
        login: loginNl,
        passwordForgotten: passwordForgottenNl,
        resetPassword: resetPasswordNl,
        manageAdmins: manageAdminsNl,
        adminDashboard: adminDashboardNl,
        registerAdmin: registerAdminNl,
        manageAdminRights: manageAdminRightsNl,
        manageCompanies: manageCompaniesNl,
        editCompanyDetails: editCompanyDetailsNl,
        editCompanyCoatings: editCompanyCoatingsNl,
        addCompany: addCompanyNl,
        coatingConfiguratorCategories: coatingConfiguratorCategoriesNl,
        editCoatingConfiguratorCategory: editCoatingConfiguratorCategoryNl,
        coatingConfiguratorSteps: coatingConfiguratorStepsNl,
        editCoatingConfiguratorStep: editCoatingConfiguratorStepNl,
        coatingConfiguratorCoatings: coatingConfiguratorCoatingsNl,
        editCoatingConfiguratorCoating: editCoatingConfiguratorCoatingNl,
        userDashboard: userDashboardNl,
        manageBranches: manageBranchesNl,
        addBranch: addBranchNl,
        editBranch: editBranchNl,
        coatingConfiguratorProcedures: coatingConfiguratorProceduresNl,
        editCoatingConfiguratorProcedure: editCoatingConfiguratorProcedureNl,
        editCompanyProcedures: editCompanyProceduresNl,
        expertAdviser: expertAdviserNl,
        customerAdviser: customerAdviserNl,
        manageRightGroups: manageRightGroupsNl,
        knowledgeBase: knowledgeBaseNl,
        knowledgeBaseCategories: knowledgeBaseCategoriesNl,
        knowledgeBaseDetail: knowledgeBaseDetailNl,
        invoices: invoicesNl,
        registerCompanyUser: registerCompanyUserNl,
        signUpCompanyUser: signUpCompanyUserNl,
        userDeliveryNotes: userDeliveryNotesNl,
        editCompanyRights: EditCompanyRightsNl,
        manageCompanyUsers: manageCompanyUsersNl
    },
    en: {
        common: commonEn,
        leftMenu: leftMenuEn,
        tabs: tabsEn,
        loginLayout: loginLayoutEn,
        login: loginEn,
        passwordForgotten: passwordForgottenEn,
        resetPassword: resetPasswordEn,
        manageAdmins: manageAdminsEn,
        adminDashboard: adminDashboardEn,
        registerAdmin: registerAdminEn,
        manageAdminRights: manageAdminRightsEn,
        manageCompanies: manageCompaniesEn,
        editCompanyDetails: editCompanyDetailsEn,
        editCompanyCoatings: editCompanyCoatingsEn,
        addCompany: addCompanyEn,
        coatingConfiguratorCategories: coatingConfiguratorCategoriesEn,
        editCoatingConfiguratorCategory: editCoatingConfiguratorCategoryEn,
        coatingConfiguratorSteps: coatingConfiguratorStepsEn,
        editCoatingConfiguratorStep: editCoatingConfiguratorStepEn,
        coatingConfiguratorCoatings: coatingConfiguratorCoatingsEn,
        editCoatingConfiguratorCoating: editCoatingConfiguratorCoatingEn,
        userDashboard: userDashboardEn,
        manageBranches: manageBranchesEn,
        addBranch: addBranchEn,
        editBranch: editBranchEn,
        coatingConfiguratorProcedures: coatingConfiguratorProceduresEn,
        editCoatingConfiguratorProcedure: editCoatingConfiguratorProcedureEn,
        editCompanyProcedures: editCompanyProceduresEn,
        expertAdviser: expertAdviserEn,
        customerAdviser: customerAdviserEn,
        manageRightGroups: manageRightGroupsEn,
        knowledgeBase: knowledgeBaseEn,
        knowledgeBaseCategories: knowledgeBaseCategoriesEn,
        knowledgeBaseDetail: knowledgeBaseDetailEn,
        invoices: invoicesEn,
        registerCompanyUser: registerCompanyUserEn,
        signUpCompanyUser: signUpCompanyUserEn,
        userDeliveryNotes: userDeliveryNotesEn,
        editCompanyRights: EditCompanyRightsEn,
        manageCompanyUsers: manageCompanyUsersEn
    }
};

const ns = Object.keys(resources.nl);

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'nl',
        fallbackLng: 'nl',
        supportedLngs: ['nl', 'en'],
        debug: process.env.NODE_ENV === 'development',
        ns,
        defaultNS: 'common',

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
